import { all } from 'redux-saga/effects';
import commonSaga from './common-sagas/common-saga';
import dashboardLiteSaga from './dashboard-lite-sagas/dashboard-lite-saga';
import individualPortalSaga from './individual-portal-sagas/individual-portal-saga';
import ssapSaga from './ssap-sagas/ssap-saga';

export default function* rootSaga() {
    yield all([
        commonSaga(),
        dashboardLiteSaga(),
        individualPortalSaga(),
        ssapSaga()
    ]);
}